import React from 'react';
import {
  Card,
  CardContent,
  CardHeader,
  IconButton,
  useMediaQuery
} from '@mui/material';
import { useManager } from '../../../pages/Manager';
import { Close } from '@mui/icons-material';
import ApplicationForm from './employeeApplicationForm/EmployeeApplicationForm';


export default function EmployeeDetails({ open, onClose }) {
  const { managerEmployee } = useManager();
  const isMobile = useMediaQuery('(max-width:600px)');
  const data = {};

  const style = isMobile ? {
    position: 'absolute',
    top: '0%',
    width: '100%',
    height: '100%'
  } : {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '80%',
    maxHeight: '90vh'
  };

  return (
    <>
      <Card sx={style}>
        <CardHeader
          title={`${managerEmployee.name} ${managerEmployee.surname}`}
          action={
            <IconButton onClick={onClose}>
              <Close />
            </IconButton>
          }
        />
        <CardContent>
          <ApplicationForm data={data}/>
        </CardContent>
      </Card>
    </>
  );
}
